module.exports = __webpack_public_path__ + "files/a9b17d657d9377cc2b1dec86db01fcf2.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-6.png
// module id = 1370
// module chunks = 59